import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]

  connect() {
    this.updateValue()
  }

  updateValue() {
    const value = this.inputTarget.value
    this.displayTarget.textContent = `${value}%`
  }
}
